<div *ngIf="isValidTicker; else elseBlock" class="container sec-yield-container">
	<div class="col-md-8 c11-text-md previous-page">
		<a class="c11n-link c11n-link--independent c11n-link--primary" (click)="backClicked()" tabindex="0">
			<span class="c11n-link__content previous-span">
				<svg class="left-arrow" >
					<use xlink:href="#link-left-small"></use>
				</svg>
				<span id="sec-yield-prev-link" class="c11n-link__text sec-yield-prev-link"> Previous page</span>
			</span>
		</a>
	</div>
		<h2 class="rps-heading-two sec-yield-h2">SEC Yield</h2>
		<p class="rps-paragraph-one" [innerHTML]="reitSecYield"></p>
</div>

<ng-template #elseBlock>
	<vmf-error></vmf-error>
</ng-template>
